import { getAnalyticsActor, posthog } from './posthog'

/**
 * Bản đồ có ô tìm vị trí: màn bản đồ vùng trồng chung và bản đồ vẽ thửa khi
 * tạo/sửa vùng của hộ.
 */
export type MapPlaceSearchEntry = 'shared_map' | 'area_editor'

/**
 * Kết quả một lần tìm vị trí:
 *   - `place`: chọn một địa điểm Google gợi ý và bản đồ đã bay tới đó.
 *   - `coords`: dán toạ độ và bản đồ đã bay tới đó.
 *   - `no_results`: Google không gợi ý được địa điểm nào cho chuỗi đã gõ.
 *   - `error`: gọi Google Places lỗi (gợi ý hoặc lấy toạ độ địa điểm).
 */
export type MapPlaceSearchOutcome = 'place' | 'coords' | 'no_results' | 'error'

/**
 * Mức dùng và kết quả của ô tìm vị trí trên bản đồ.
 *
 * KHÔNG gửi chuỗi đã gõ, tên/địa chỉ/toạ độ địa điểm: chuỗi tìm có thể là địa
 * chỉ nhà hộ trồng. Chỉ gửi enum. Analytics lỗi hoặc tắt không chặn việc tìm.
 */
export function captureMapPlaceSearch(input: {
    entry: MapPlaceSearchEntry
    outcome: MapPlaceSearchOutcome
}) {
    try {
        const actor = getAnalyticsActor()
        if (!actor) return
        posthog.capture('map_place_search', {
            schema_version: 1,
            event_id: crypto.randomUUID(),
            ...actor,
            entry: input.entry,
            outcome: input.outcome,
        })
    } catch {
        // Analytics không được chặn việc tìm vị trí trên bản đồ.
    }
}
